import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { ComposeProvider } from './lib/compose';
import App from './App';
import './styles/base.css';
import './styles/topbar.css';
import './styles/paper.css';
import './styles/postview.css';
import './styles/compose.css';
import './styles/profile.css';
import './styles/manage.css';
import './styles/dashboard.css';
import './styles/welcome.css';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <ComposeProvider>
                    <App />
                </ComposeProvider>
            </AuthProvider>
        </BrowserRouter>
    </StrictMode>,
);
